import Vue from 'vue';

import AdminCheckbox from '~/components/original/AdminCheckbox.vue';
import AdminDatePicker from '~/components/original/AdminDatePicker.vue';
import AdminEditDialog from '~/components/original/AdminEditDialog.vue';
import AdminImportDialog from '~/components/original/AdminImportDialog.vue';
import AdminRadioButton from '~/components/original/AdminRadioButton.vue';
import AdminSelectCriteriumCode from '~/components/original/AdminSelectCriteriumCode.vue';
import AdminSelectSecurityGroupCode from '~/components/original/AdminSelectSecurityGroupCode.vue';
import AdminSelectTrainingCourseCode from '~/components/original/AdminSelectTrainingCourseCode.vue';
import AdminSelectTrainingModuleCode from '~/components/original/AdminSelectTrainingModuleCode.vue';
import AdminSelectTrainingSectionCode from '~/components/original/AdminSelectTrainingSectionCode.vue';
import AdminSelectUserGroupCode from '~/components/original/AdminSelectUserGroupCode.vue';
import AdminSelectUsername from '~/components/original/AdminSelectUsername.vue';
import AdminSelectVoucherCode from '~/components/original/AdminSelectVoucherCode.vue';
import AdminSwitch from '~/components/original/AdminSwitch.vue';
import AdminTextarea from '~/components/original/AdminTextarea.vue';
import AdminTextareaMarkdown from '~/components/original/AdminTextareaMarkdown.vue';
import AdminTextField from '~/components/original/AdminTextField.vue';
import AppMenuSlideItem from '~/components/original/AppMenuSlideItem.vue';
import BuilderAppDialog from '~/components/original/BuilderAppDialog.vue';
import BuilderComponentDialog from '~/components/original/BuilderComponentDialog.vue';
import BuilderFileInput from '~/components/original/BuilderFileInput.vue';
import BuilderOtherDialog from '~/components/original/BuilderOtherDialog.vue';
import BuilderPageDialog from '~/components/original/BuilderPageDialog.vue';
import BuilderPreviewSlideItem from '~/components/original/BuilderPreviewSlideItem.vue';
import BuilderTrainingDialog from '~/components/original/BuilderTrainingDialog.vue';
import CardBigChart from '~/components/original/CardBigChart.vue';
import CardCarousel from '~/components/original/CardCarousel.vue';
import CardChart from '~/components/original/CardChart.vue';
import CardGChart from '~/components/original/CardGChart.vue';
import CardVideo from '~/components/original/CardVideo.vue';
import CarouselVideo from '~/components/original/CarouselVideo.vue';
import ChatList from '~/components/original/ChatList.vue';
import ClipboardButton from '~/components/original/ClipboardButton.vue';
import CollapsedMenuSlideItem from '~/components/original/CollapsedMenuSlideItem.vue';
import DebuggerButton from '~/components/original/DebuggerButton.vue';
import DebuggerDialog from '~/components/original/DebuggerDialog.vue';
import DebuggerFirebaseAlert from '~/components/original/DebuggerFirebaseAlert.vue';
import DebuggerOrderAlert from '~/components/original/DebuggerOrderAlert.vue';
import EnvInfoSystemBar from '~/components/original/EnvInfoSystemBar.vue';
import InformationDialog from '~/components/original/InformationDialog.vue';
import InformationSnackbar from '~/components/original/InformationSnackbar.vue';
import InputCheckbox from '~/components/original/InputCheckbox.vue';
import InputCombobox from '~/components/original/InputCombobox.vue';
import InputComboboxMultiple from '~/components/original/InputComboboxMultiple.vue';
import InputDatePicker from '~/components/original/InputDatePicker.vue';
import InputRadioButton from '~/components/original/InputRadioButton.vue';
import InputSelect from '~/components/original/InputSelect.vue';
import InputSelectMultiple from '~/components/original/InputSelectMultiple.vue';
import InputSlider from '~/components/original/InputSlider.vue';
import InputSwitch from '~/components/original/InputSwitch.vue';
import InputTextarea from '~/components/original/InputTextarea.vue';
import InputTextField from '~/components/original/InputTextField.vue';
import MenuList from '~/components/original/MenuList.vue';
import MessagebarAttachmentDialog from '~/components/original/MessagebarAttachmentDialog.vue';
import MessagebarChatDialog from '~/components/original/MessagebarChatDialog.vue';
import MessagebarFooter from '~/components/original/MessagebarFooter.vue';
import MessagebarTagDialog from '~/components/original/MessagebarTagDialog.vue';
import MessagebarTitleDialog from '~/components/original/MessagebarTitleDialog.vue';
import MessagebarToDialog from '~/components/original/MessagebarToDialog.vue';
import PointInputVoucherCodeDialog from '~/components/original/PointInputVoucherCodeDialog.vue';
import ProgressCircular from '~/components/original/ProgressCircular.vue';
import ProgressLinear from '~/components/original/ProgressLinear.vue';
import SearchbarList from '~/components/original/SearchbarList.vue';
import SettingList from '~/components/original/SettingList.vue';
import SettingNavigationDrawer from '~/components/original/SettingNavigationDrawer.vue';
import TabMenuSlideItem from '~/components/original/TabMenuSlideItem.vue';
import TimelineMessageBodyCard from '~/components/original/TimelineMessageBodyCard.vue';
import TimelineMessageHeaderCard from '~/components/original/TimelineMessageHeaderCard.vue';
import Toolbar from '~/components/original/Toolbar.vue';
import ToolbarTabs from '~/components/original/ToolbarTabs.vue';
import UserMenuSlideItem from '~/components/original/UserMenuSlideItem.vue';
import VersionInfoFooter from '~/components/original/VersionInfoFooter.vue';
// custom bri life start
import CustomBriLifeLotteryDialog from '~/components/custom/CustomBriLifeLotteryDialog.vue';
// custom bri life end

Vue.component(AdminCheckbox.name, AdminCheckbox)
Vue.component(AdminDatePicker.name, AdminDatePicker)
Vue.component(AdminEditDialog.name, AdminEditDialog)
Vue.component(AdminImportDialog.name, AdminImportDialog)
Vue.component(AdminRadioButton.name, AdminRadioButton)
Vue.component(AdminSelectCriteriumCode.name, AdminSelectCriteriumCode)
Vue.component(AdminSelectSecurityGroupCode.name, AdminSelectSecurityGroupCode)
Vue.component(AdminSelectTrainingCourseCode.name, AdminSelectTrainingCourseCode)
Vue.component(AdminSelectTrainingModuleCode.name, AdminSelectTrainingModuleCode)
Vue.component(AdminSelectTrainingSectionCode.name, AdminSelectTrainingSectionCode)
Vue.component(AdminSelectUserGroupCode.name, AdminSelectUserGroupCode)
Vue.component(AdminSelectUsername.name, AdminSelectUsername)
Vue.component(AdminSelectVoucherCode.name, AdminSelectVoucherCode)
Vue.component(AdminSwitch.name, AdminSwitch)
Vue.component(AdminTextarea.name, AdminTextarea)
Vue.component(AdminTextareaMarkdown.name, AdminTextareaMarkdown)
Vue.component(AdminTextField.name, AdminTextField)
Vue.component(AppMenuSlideItem.name, AppMenuSlideItem)
Vue.component(BuilderAppDialog.name, BuilderAppDialog)
Vue.component(BuilderComponentDialog.name, BuilderComponentDialog)
Vue.component(BuilderFileInput.name, BuilderFileInput)
Vue.component(BuilderOtherDialog.name, BuilderOtherDialog)
Vue.component(BuilderPageDialog.name, BuilderPageDialog)
Vue.component(BuilderPreviewSlideItem.name, BuilderPreviewSlideItem)
Vue.component(BuilderTrainingDialog.name, BuilderTrainingDialog)
Vue.component(CardBigChart.name, CardBigChart)
Vue.component(CardCarousel.name, CardCarousel)
Vue.component(CardChart.name, CardChart)
Vue.component(CardGChart.name, CardGChart)
Vue.component(CardVideo.name, CardVideo)
Vue.component(CarouselVideo.name, CarouselVideo)
Vue.component(ChatList.name, ChatList)
Vue.component(ClipboardButton.name, ClipboardButton)
Vue.component(CollapsedMenuSlideItem.name, CollapsedMenuSlideItem)
Vue.component(DebuggerButton.name, DebuggerButton)
Vue.component(DebuggerDialog.name, DebuggerDialog)
Vue.component(DebuggerFirebaseAlert.name, DebuggerFirebaseAlert)
Vue.component(DebuggerOrderAlert.name, DebuggerOrderAlert)
Vue.component(EnvInfoSystemBar.name, EnvInfoSystemBar)
Vue.component(InformationDialog.name, InformationDialog)
Vue.component(InformationSnackbar.name, InformationSnackbar)
Vue.component(InputCheckbox.name, InputCheckbox)
Vue.component(InputCombobox.name, InputCombobox)
Vue.component(InputComboboxMultiple.name, InputComboboxMultiple)
Vue.component(InputDatePicker.name, InputDatePicker)
Vue.component(InputRadioButton.name, InputRadioButton)
Vue.component(InputSelect.name, InputSelect)
Vue.component(InputSelectMultiple.name, InputSelectMultiple)
Vue.component(InputSlider.name, InputSlider)
Vue.component(InputSwitch.name, InputSwitch)
Vue.component(InputTextarea.name, InputTextarea)
Vue.component(InputTextField.name, InputTextField)
Vue.component(MenuList.name, MenuList)
Vue.component(MessagebarAttachmentDialog.name, MessagebarAttachmentDialog)
Vue.component(MessagebarChatDialog.name, MessagebarChatDialog)
Vue.component(MessagebarFooter.name, MessagebarFooter)
Vue.component(MessagebarTagDialog.name, MessagebarTagDialog)
Vue.component(MessagebarTitleDialog.name, MessagebarTitleDialog)
Vue.component(MessagebarToDialog.name, MessagebarToDialog)
Vue.component(PointInputVoucherCodeDialog.name, PointInputVoucherCodeDialog)
Vue.component(ProgressCircular.name, ProgressCircular)
Vue.component(ProgressLinear.name, ProgressLinear)
Vue.component(SearchbarList.name, SearchbarList)
Vue.component(SettingList.name, SettingList)
Vue.component(SettingNavigationDrawer.name, SettingNavigationDrawer)
Vue.component(TabMenuSlideItem.name, TabMenuSlideItem)
Vue.component(TimelineMessageBodyCard.name, TimelineMessageBodyCard)
Vue.component(TimelineMessageHeaderCard.name, TimelineMessageHeaderCard)
Vue.component(Toolbar.name, Toolbar)
Vue.component(ToolbarTabs.name, ToolbarTabs)
Vue.component(UserMenuSlideItem.name, UserMenuSlideItem)
Vue.component(VersionInfoFooter.name, VersionInfoFooter)
// custom bri life start
Vue.component(CustomBriLifeLotteryDialog.name, CustomBriLifeLotteryDialog)
// custom bri life end
